import React from 'react';

import { SVGComponentProps } from './svg.types';

const TaskHistoryMovetaskSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="#EEF1FC" />
        <g clipPath="url(#clip0_6149_102121)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.23 11.616L21.26 11.625C21.7224 11.6276 22.1649 11.8132 22.491 12.1411C22.817 12.469 23 12.9126 23 13.375V20.375C23.0003 20.6053 22.955 20.8334 22.8669 21.0462C22.7787 21.2589 22.6493 21.4522 22.4863 21.6148C22.3232 21.7774 22.1296 21.9062 21.9165 21.9938C21.7035 22.0813 21.4753 22.1259 21.245 22.125H10.756C10.2914 22.1247 9.84581 21.9405 9.51673 21.6125C9.18764 21.2846 9.00185 20.8396 9 20.375V11.625C9 11.1617 9.18369 10.7174 9.51079 10.3893C9.8379 10.0613 10.2817 9.87632 10.745 9.875H14.9C15.272 9.8813 15.6284 10.0256 15.9 10.28L17.23 11.616ZM17.7537 19.8101L19.7982 17.8136C19.8615 17.752 19.9119 17.6785 19.9465 17.5973C19.9812 17.5161 19.9993 17.4288 20 17.3405C20.0006 17.2522 19.9837 17.1647 19.9503 17.083C19.9168 17.0012 19.8674 16.927 19.805 16.8645L17.8028 14.8572C17.7409 14.7951 17.6674 14.7458 17.5864 14.7121C17.5055 14.6784 17.4187 14.661 17.331 14.6609C17.2433 14.6608 17.1565 14.6779 17.0754 14.7113C16.9944 14.7448 16.9207 14.7938 16.8586 14.8557C16.7965 14.9176 16.7472 14.9912 16.7135 15.0721C16.6798 15.1531 16.6624 15.2399 16.6623 15.3276C16.6622 15.4152 16.6793 15.5021 16.7127 15.5831C16.7462 15.6642 16.7953 15.7379 16.8572 15.8L17.7143 16.6611H15.3252C14.8 16.6611 14.2961 16.4534 13.9234 16.0834C13.5506 15.7134 13.3394 15.2109 13.3356 14.6857V14.4395C13.3382 14.3501 13.3229 14.2612 13.2905 14.1779C13.2581 14.0946 13.2093 14.0187 13.1471 13.9546C13.0848 13.8904 13.0103 13.8395 12.928 13.8047C12.8457 13.7699 12.7573 13.752 12.6679 13.752C12.5785 13.752 12.4901 13.7699 12.4078 13.8047C12.3255 13.8395 12.251 13.8904 12.1887 13.9546C12.1264 14.0187 12.0777 14.0946 12.0453 14.1779C12.0129 14.2612 11.9976 14.3501 12.0002 14.4395V14.6857C12.0043 15.5651 12.3563 16.4071 12.9794 17.0277C13.6024 17.6483 14.4458 17.997 15.3252 17.9976H17.6994L16.8212 18.8547C16.7584 18.9159 16.7084 18.9889 16.6738 19.0695C16.6393 19.1501 16.621 19.2367 16.6199 19.3243C16.6189 19.412 16.6351 19.499 16.6677 19.5804C16.7002 19.6618 16.7485 19.7359 16.8097 19.7987C16.871 19.8614 16.9439 19.9115 17.0245 19.946C17.1051 19.9805 17.1917 19.9988 17.2793 19.9999C17.367 20.001 17.454 19.9847 17.5354 19.9522C17.6168 19.9196 17.691 19.8713 17.7537 19.8101Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0_6149_102121">
            <rect width="14" height="14" fill="white" transform="translate(9 9)" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default TaskHistoryMovetaskSVG;
